module.exports = __webpack_public_path__ + "img/tv.81677289.svg";